import {
  boolean,
  doublePrecision,
  index,
  integer,
  jsonb,
  pgTable,
  text,
  timestamp,
  uniqueIndex,
} from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";
import { nanoid } from "nanoid";

export const branches = pgTable(
  "branches",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    code: text("code").notNull().unique(),
    name: text("name").notNull(),
    phone: text("phone"),
    address: text("address"),
    lat: doublePrecision("lat"),
    lng: doublePrecision("lng"),
    serviceRadiusM: integer("service_radius_m"),
    timezone: text("timezone").default("Asia/Vientiane"),
    openHoursJson: jsonb("open_hours_json").$type<Record<
      string,
      { open: string; close: string } | null
    > | null>(),
    isActive: boolean("is_active").notNull().default(true),
    isDistributionHub: boolean("is_distribution_hub").notNull().default(false),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    updatedAt: timestamp("updated_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    index("branches_code_idx").on(t.code),
    index("branches_active_idx").on(t.isActive),
    uniqueIndex("branches_distribution_hub_uidx")
      .on(t.isDistributionHub)
      .where(sql`${t.isDistributionHub} = true`),
  ],
);

export const branchSettings = pgTable("branch_settings", {
  branchId: text("branch_id")
    .primaryKey()
    .references(() => branches.id, { onDelete: "cascade" }),
  pickupEnabled: boolean("pickup_enabled").notNull().default(true),
  deliveryEnabled: boolean("delivery_enabled").notNull().default(true),
  onlineOrdersEnabled: boolean("online_orders_enabled").notNull().default(true),
  autoAccept: boolean("auto_accept").notNull().default(false),
  capacityPerSlot: integer("capacity_per_slot"),
  slotConfigJson: jsonb("slot_config_json").$type<{
    slotDurationMinutes?: number;
    slots?: Array<{ start: string; end: string }>;
  } | null>(),
  cutoffMinutes: integer("cutoff_minutes"),
  prepBufferMinutes: integer("prep_buffer_minutes"),
  blackoutDatesJson: jsonb("blackout_dates_json").$type<
    Array<{
      id?: string;
      date: string;
      allDay?: boolean;
      startTime?: string | null;
      endTime?: string | null;
      reason?: string | null;
    }> | null
  >(),
  createdAt: timestamp("created_at", {
    withTimezone: true,
    mode: "date",
  }).notNull(),
  updatedAt: timestamp("updated_at", {
    withTimezone: true,
    mode: "date",
  }).notNull(),
});
